<template>
  <div
    class="c-serviceSearchHeader"
    :class="{ 'c-serviceSearchHeader-noBorder': layoutType === 'Block' && !isPC }"
  >
    <div class="c-serviceSearchHeaderColA">
      <div
        class="c-serviceSearchHeaderResult"
        v-if="isLoading || (total > 0 || !isPC)"
      >
        <div
          class="c-serviceSearchHeaderHits"
          v-if="total > 0"
        >
          <span class="c-serviceSearchHeaderHits_total">{{ totalCountText }}</span>
          件中
          <span v-if="isLoading">-</span>
          <span v-else>{{ startCountText }} - {{ endCountText }}</span>
          件表示
        </div>
      </div>

      <div class="c-serviceSearchHeaderLayout c-serviceSearchHeaderLayout-sp">
        <div class="c-serviceSearchHeaderLayout_wrapper">
          <c-button
            class="c-serviceSearchHeaderLayout_button c-serviceSearchHeaderLayout_buttonList"
            :class="isList ? 'c-serviceSearchHeaderLayout_button-active' : ''"
            @click="setCookieLayout($store.state.constants.serviceLayout.list)"
          >
            <coconala-icon name="list" />
          </c-button>
          <c-button
            class="c-serviceSearchHeaderLayout_button c-serviceSearchHeaderLayout_buttonBlock"
            :class="!isList ? 'c-serviceSearchHeaderLayout_button-active' : ''"
            @click="setCookieLayout($store.state.constants.serviceLayout.block)"
          >
            <coconala-icon name="blocks" />
          </c-button>
        </div>
      </div>
    </div>

    <div
      class="c-serviceSearchHeaderColB"
      :class="{ 'c-serviceSearchHeaderColB_fixed': isFixed }"
    >
      <div class="c-serviceSearchHeaderColB_switchGroup">
        <div class="c-serviceSearchHeaderFullCorrespondence c-serviceSearchHeaderFullCorrespondence-pc">
          <search-full-correspondence
            :value="innerCondition.excludeFullCorrespondence"
            @input="setAttributes('excludeFullCorrespondence', $event)"
            v-if="isPC && innerCondition.serviceClass !== '1'"
          />
        </div>
        <div
          v-if="isPC && innerCondition.sortBy !== 'new'"
          class="c-serviceSearchCertification"
        >
          <SearchCertificationDivination
            v-if="parentCategoryId === CATEGORY_DIVINATION_ID"
            :value="innerCondition.certificationDivinationPriorityDisplay"
            @input="setChangeAttributes('certificationDivinationPriorityDisplay', $event)"
          />
          <SearchProPriority
            v-else
            :value="innerCondition.proPriorityDisplay"
            @input="setChangeAttributes('proPriorityDisplay', $event)"
          />
        </div>
        <div class="c-serviceSearchHeaderFullCorrespondence c-serviceSearchHeaderFullCorrespondence-sp">
          <search-full-correspondence
            :value="innerCondition.excludeFullCorrespondence"
            @input="setAttributes('excludeFullCorrespondence', $event)"
            v-if="innerCondition.serviceClass !== '1'"
          />
        </div>
      </div>


      <div class="c-serviceSearchHeader_searchAndFilter">
        <Portal
          to="searchConditionSort"
          :disabled="!isFixedSearchCondition"
        >
          <div class="c-serviceSearchHeaderColB_inner">
            <div class="c-serviceSearchHeaderSort">
              <DSelectCustomizeTrigger
                v-model="innerCondition.sortBy"
                @input="setAttributes('sortBy', $event)"
              >
                <template #trigger>
                  <a
                    href="#"
                    class="c-serviceSearchHeaderSort_trigger"
                  >
                    <CoconalaIcon
                      class="c-serviceSearchHeaderSort_triggerIcon"
                      name="swap-vertical"
                      :size="isPC ? '18px' : '15px'"
                    />
                    <span>{{ sortCurrentName }}</span>
                  </a>
                </template>
                <template #option>
                  <option
                    v-for="type in sortTypes"
                    :value="type.value"
                    :key="type.name"
                  >{{ type.name }}</option>
                </template>
              </DSelectCustomizeTrigger>
            </div>

            <div class="c-serviceSearchHeaderLayout c-serviceSearchHeaderLayout-pc">
              <div v-if="isPC">
                <!-- TODO: category_v2 DS2コンポーネントで定義したアイコンに差し替える -->
                <CButton
                  class="c-serviceSearchHeaderLayout_button c-serviceSearchHeaderLayout_buttonList"
                  :class="isList ? 'c-serviceSearchHeaderLayout_button-active' : ''"
                  @click="setCookieLayout($store.state.constants.serviceLayout.list)"
                >
                  <CoconalaIcon name="list" />
                </CButton>
                <CButton
                  class="c-serviceSearchHeaderLayout_button c-serviceSearchHeaderLayout_buttonBlock"
                  :class="!isList ? 'c-serviceSearchHeaderLayout_button-active' : ''"
                  @click="setCookieLayout($store.state.constants.serviceLayout.block)"
                >
                  <CoconalaIcon name="blocks" />
                </CButton>
              </div>
            </div>
          </div>
        </Portal>
        <PortalTarget
          v-if="!isPC"
          name="searchConditionModalFullTrigger" />
      </div>
    </div>
  </div>
</template>
<script>
import SearchFullCorrespondence from './components/SearchFullCorrespondence'
import DSelectCustomizeTrigger from '~/components/molecules/DS2/DSelectCustomizeTrigger'

import { mapState, mapGetters } from 'vuex'
import SearchProPriority from './components/SearchProPriority'
import SearchCertificationDivination from './components/SearchCertificationDivination'

const SORT_TYPES_ORIGIN = [
  { value: 'recommend', name: 'おすすめ順' },
  { value: 'new', name: '新着' },
  { value: 'ranking', name: 'ランキング' },
  { value: 'fav', name: 'お気に入り数順' }
]

const CATEGORY_DIVINATION_ID = 3

export default {
  name: 'ServiceSearchHeader',
  components: {
    SearchFullCorrespondence,
    DSelectCustomizeTrigger,
    SearchProPriority,
    SearchCertificationDivination
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    totalCountText: {
      type: String,
      default: ''
    },
    startCountText: {
      type: String,
      default: ''
    },
    endCountText: {
      type: String,
      default: ''
    },
    layoutType: {
      type: String,
      default: ''
    },
    condition: {
      type: Object,
      default() {
        return {}
      }
    },
    isList: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isFixedSearchCondition: {
      type: Boolean,
      default: false
    },
    parentCategoryId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      innerCondition: {},
      attributes: this.getMergedAttributes(this.queries),
      isFixed: false,
      isTicking: false,
      CATEGORY_DIVINATION_ID
    }
  },
  watch: {
    attributes: {
      deep: true,
      handler(v) {
        this.$emit('change', v)
      }
    },
    condition: {
      deep: true,
      handler(v) {
        this.innerCondition = this.$util.clone(this.condition)
      }
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapState('auth/user', ['isBusiness', 'isBeginner']),
    sortTypes() {
      if (!this.isBusiness && !this.$route.query.is_business) {
        return [...SORT_TYPES_ORIGIN, { value: 'beginner', name: '初心者向け' }]
      }
      return SORT_TYPES_ORIGIN
    },
    sortCurrentName() {
      const target = this.sortTypes.find(s => s.value === this.innerCondition.sortBy)
      return target ? target.name : ''
    }
  },
  methods: {
    getMergedAttributes(newValue = {}) {
      let camelValue = this.$util.toCamelCaseObject(newValue)
      let categoryId = Number(this.$route.params.categoryId)
      if (!categoryId && this.$route.query.category_id) {
        categoryId = this.$route.query.category_id
      }
      let attributes = {
        categoryId: categoryId
      }
      return Object.assign(attributes, camelValue)
    },
    setAttributes(key, event) {
      this.$set(this.attributes, key, event)
    },
    setChangeAttributes(key, value, emitChangeEvent = true) {
      this.$emit('change-attributes', {
        key,
        value,
        emitChangeEvent
      })
    },
    changeLayout(layoutType) {
      let newQuery = { ...this.$route.query, ...{ layout: layoutType } }
      delete newQuery['page']
      return newQuery
    },
    setCookieLayout(layoutType) {
      this.setAttributes('layout', layoutType)
      this.$cookies.set('search_layout', layoutType, {
        path: '/',
        maxAge: 60 * 60 * 24 * 365
      })
    },
    monitoringHeaderPosition() {
      if (this.isPC) {
        return
      }
      if (!this.isTicking) {
        window.requestAnimationFrame(() => {
          this.isTicking = false
          const position = this.$el.getBoundingClientRect().top + window.pageYOffset
          const scrollY = window.scrollY
          if (position < scrollY) {
            this.isFixed = true
          } else if (position > scrollY) {
            this.isFixed = false
          }
        })
        this.isTicking = true
      }
    }
  },
  created() {
    this.innerCondition = this.$util.clone(this.condition)
  },
  mounted() {
    window.addEventListener('scroll', this.monitoringHeaderPosition)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.monitoringHeaderPosition)
  }
}
</script>
<style lang="scss" scoped>
.c-serviceSearchHeader {
  display: flex;
  margin-top: 16px;
  padding-bottom: 8px;

  flex-wrap: wrap;

  &-noBorder {
    border: none;
  }

  &_searchAndFilter {
    display: flex;
  }
}

.c-serviceSearchHeaderColA {
  display: flex;
  min-width: fit-content;

  align-items: center;
}

.c-serviceSearchHeaderColB {
  display: flex;
  flex: 1;

  align-items: center;
  justify-content: space-between;
  &_switchGroup {
    display: flex;
    word-break: keep-all;

    align-items: center;
  }
  &_inner {
    display: flex;

    align-items: center;
  }
}

.c-serviceSearchHeaderResult {
  display: flex;
  margin-right: 24px;
  min-width: 140px;

  align-self: center;
}

.c-serviceSearchHeaderSort {
  margin-right: 20px;

  flex-basis: 200px;

  &_trigger {
    display: flex;
    color: $ds2-color-brand-secondary;
    white-space: nowrap;
    font-size: 15px;

    align-items: center;
  }
  &_triggerIcon {
    margin-right: 4px;
  }

  /deep/ .d-select {
    min-width: 170px;
  }

  /deep/ .select {
    display: flex;

    align-items: center;

    &.is-empty {
      select {
        color: $color-gray-800;
      }
    }

    select {
      padding: 6px 12px !important;
      height: 32px !important;
    }

    &::after {
      top: -5px !important;
    }
  }
}

/deep/ .c-serviceSearchHeaderLayout {
  position: relative;
  flex: 0 1 auto;
  font-size: 20px;

  &_wrapper {
    display: flex;

    align-items: center;
  }

  &_button {
    &.button {
      padding: 0;
      height: 40px;
      border: 0;
      background: transparent;
      color: $ds2-color-gray-200;
      font-size: 20px;

      &:focus:not(:active),
      &.is-focused:not(:active) {
        box-shadow: none;
      }
    }

    &-active {
      &.button {
        color: $ds2-color-gray-600;
      }
    }
  }

  &_buttonList {
    .coconala-icon {
      vertical-align: -2px;
    }
  }

  &_buttonBlock {
    margin-left: 8px;

    .coconala-icon {
      vertical-align: -2px;
    }
  }
}

.c-serviceSearchHeaderHits {
  display: inline-block;
  color: $ds2-color-gray-600;
  letter-spacing: 0.04em;
  font-size: 12px;
}

@media (min-width: breakpoint(Search, M) + 1) {
  /deep/ .c-serviceSearchHeaderLayout {
    &-pc {
      min-width: 60px;
    }

    &-sp {
      display: none;
    }
  }

  .c-serviceSearchHeaderFullCorrespondence {
    &-pc {
      margin-right: 24px;
    }

    &-sp {
      display: none;
    }
  }

  .c-serviceSearchCertification {
    /deep/ .dropdown-menu {
      z-index: z(dropdown-upper, content);
    }
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-serviceSearchHeader {
    flex-direction: column;
    margin-top: 0;
    padding: 0;
    height: auto;

    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .c-serviceSearchHeaderColA {
    display: flex;
    margin-bottom: 0;
    padding: 8px 12px;
    min-height: 32px;

    align-items: center;
    justify-content: space-between;
  }

  .c-serviceSearchHeaderColB {
    display: flex;
    flex: 1;
    padding: 0 12px 8px;
    min-height: 40px;

    justify-content: space-between;

    &_fixed {
      position: fixed;
      top: 0;
      z-index: z(header, main);
      padding: 12px 8px;
      width: 100%;
      background-color: $ds2-color-gray-10;
    }
  }

  .c-serviceSearchHeaderResult {
    text-align: left;

    flex-basis: auto;
  }

  .c-serviceSearchHeaderLayout {
    padding-top: 0;
    font-size: 18px;

    &_button {
      &.button {
        height: 32px;
        font-size: 18px;
      }
    }

    &-pc {
      display: none;
    }
  }

  .c-serviceSearchHeaderHits {
    display: block;
    margin-right: 0;
    font-size: 14px;
  }

  .c-serviceSearchHeaderFullCorrespondence {
    position: relative;
    top: 0;
    color: $ds2-color-gray-900;

    &-pc {
      display: none;
    }
  }

  .c-serviceSearchHeaderSort {
    margin-right: 0;

    flex-basis: 150px;

    &_trigger {
      font-size: 13px;
    }

    /deep/ .d-select {
      min-width: 168px;
    }
  }
}
</style>
